<template>
  <div>
    <el-select :value="status" value-key="key" :size="size" :placeholder="$t('table.waybill_name')" @input="change($event)" :clearable="true">
      <el-option label="EMS" value="EMS" />
      <el-option label="申通" value="申通" />
      <el-option label="顺丰" value="顺丰" />
      <el-option label="京东" value="京东" />
      <el-option label="中通" value="中通" />
      <el-option label="圆通" value="圆通" />
      <el-option label="韵达" value="韵达" />
      <el-option label="天天" value="天天" />
      <el-option label="国通" value="国通" />
      <el-option label="全峰" value="全峰" />
      <el-option label="速尔" value="速尔" />
      <el-option label="快捷" value="快捷" />
      <el-option label="优速" value="优速" />
      <el-option label="邮政" value="邮政" />
      <el-option label="急宅送" value="急宅送" />
      <el-option label="百世汇通" value="百世汇通" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      status: 'EMS'
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.status = val
      this.$emit('input', this.status)
    }
  },
  mounted () {
    this.status = this.value
  },
  watch: {
    value: function (val, oldVal) {
      this.status = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/WayBillCompanySelect.vue